import { StyleSheet, View } from 'react-native'
import { Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: Spacing.M,
  },
  text: {
    textAlign: 'center',
  },
})

const FirmwareComplete = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.text}>Firmware has been updated successfully</Text>
    </View>
  )
}

export default FirmwareComplete
